import React, { useState } from "react";
import { useSelector } from "react-redux";
import { i18n } from '../../../translate/i18n';
import AddCircleOutline from '@mui/icons-material/AddCircleOutline';
import ModalAttachmentFilesEquipmentModel from '../Modals/ModalAttachmentFilesEquipmentModel';
import {
  Paper, Typography, Button, Dialog, CircularProgress, Divider,
} from '@mui/material';
import { FormStyled, styleModal } from '../../../containers/Admin/Forms/styles'
import AttachmentsViewer from "../../../UI/AttachmentsViewer/AttachmentsViewer";

export default function AttachmentsList(props) {
  const styles = {
    table: {
      position: 'relative',
    },
    opacityContainer: {
    },
    spinner: {
      position: 'absolute',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      height: '100%',
      top: '-5px',
      opacity: '1',
      zIndex: 2,
    },
    noResults: {
      textAlign: 'center'
    },
    deleteTextConfirm: {
      marginLeft: '-30px',
      fontWeight: 'bold',
    },
    editWidth: {
      width: '90%'
    },
    avatarContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center'
    },
    avatar: {
      width: 50,
      height: 50,
    },
    avatarSmallText: {
      fontSize: 12,
      width: 50,
      height: 50,
    },
    chip: {
      margin: 5,
    },
    thumbUp: {
      marginRight: 15,
      color: "#349c34"
    },
    thumbDown: {
      marginRight: 15,
      color: "#d04545"
    },
    statusContainer: {
      display: 'flex',
      alignItems: 'center',
    },
    headerButtonsContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    }
  }

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState(false);
  const [modalContent, setModalContent] = useState({});

  // get from redux
  const attachments = useSelector((state) => state.equipmentModels.equipmentModel.attachments);

  const loading = useSelector((state) => state.equipmentModels.loading)
  const selectedAccess = useSelector((state) => state.auth.selectedAccess)
  const loadingEquipmentModels = useSelector(state => state.equipmentModels.loading);
  const role = selectedAccess.role

  const setOpenModal = (open, type, doc = {}) => {
    setIsModalOpen(open);
    setModalType(type);
    setModalContent(doc)
  }

  return (
    <Paper>
      <FormStyled style={{ opacity: loadingEquipmentModels ? '0.3' : '1' }}>
        <Dialog
          scroll='body'
          fullWidth
          open={isModalOpen}
          onClose={() => setOpenModal(false, 'close')}
          PaperProps={{
            style: styleModal,
          }}
        >
          <ModalAttachmentFilesEquipmentModel
            type={modalType}
            closeModal={setOpenModal}
            modalContent={modalContent}
          />
        </Dialog>
        <div style={styles.headerButtonsContainer}>
          <Typography variant='h6' style={{ padding: '20px 20px 20px 0' }}>
            {
            i18n.t('attachmentFilesEquipmentModelsTypo.label')
            }
          </Typography>
          {role === 'admin' &&
            <Button
              style={{marginRight: 40}}
              variant='outlined'
              aria-label="add"
              onClick={() => setOpenModal(true, 'new', {})}
              startIcon={<AddCircleOutline />}
            >
              {i18n.t('supportBtn.label')}
            </Button>
          }
        </div>
        <Divider style={{marginBottom: 10}}/>
        {loading &&
          <div style={styles.spinner}>
            <CircularProgress />
          </div>
        }
        {attachments && attachments.length === 0 && !loading ?
          <div style={styles.noResults}>
            {!loading && <Typography>{i18n.t('attachmentFilesEquipmentModelsTypo.noResults')}</Typography>}
          </div>
          :
          <AttachmentsViewer role={role} attachments={attachments} setOpenModal={(attachment) => setOpenModal(true, 'edit', attachment)} />
        }
      </FormStyled>
    </Paper>
  );

}
